import { Box } from "../../../../../components";
import {
  RenderApprovalHistory,
  RenderComment,
} from "../../../human-organization/summary-employee-request/utils/render-helper";
import CommentSection from "../../../info-technology-process/commentsection/comment-sections";
import { useGetDetailRequests } from "../hooks/get-detail-request";
import { Skeleton } from "antd";
import { useSelector } from "../../../../../store/store";
import { getApproverName, getEmployeeDetail } from "../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { useEmployee } from "../../../../../hook";
import { isEnableAccept } from "../../../human-organization/summary-employee-request/utils/step";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";

export const History = ({ form }: { form: any }) => {
  const user = useSelector((state) => state.user);
  const { data: detail, isLoading } = useGetDetailRequests();
  const { data: employees  } = useEmployee();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { getITLeadITHeadAssignee } = useSoftwares();

  const history = [
    {
      status: detail?.fields?.eApprovedStatus,
      name:
        detail?.fields?.eApprovedName ||
        detail?.fields?.eApprovedBy?.split("|")?.[1] ||
        getEmployeeDetail(
          detail?.fields?.eApprovedBy?.toLowerCase(),
          employees,
          softwares
        )?.[0]?.Title,
      approvedDate: detail?.fields?.eApprovedDate,
      title: "Thủ trưởng cơ quan đơn vị",
      comment: detail.fields.eApprovalComments,
    },
    {
      status: detail?.fields?.eApprovedByITLeadStatus,
      name: getApproverName(
        detail?.fields?.eApprovedByITLead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.SR).eAssignee
      ),
      approvedDate: detail?.fields?.eApprovedByITLeadDate,
      title: "Bộ phận hành chính VPCT",
      comment: detail.fields.eITLeadComment,
    },
  ];

  if (isLoading) return <Skeleton />;

  return (
    <>
      <Box title="Lịch sử phê duyệt">
        <RenderApprovalHistory history={history} />
        <RenderComment
          form={form}
          disabled={!isEnableAccept(detail, user.current.username)}
        />
      </Box>

      <Box title="Thông tin trao đổi">
        <CommentSection
          comments={[]}
          data={detail}
          user={user}
          id={18}
          className="mb-4"
        />
      </Box>
    </>
  );
};
